class CosmicTestimonialSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.cosmic-testimonial-slider__track');
    this.slides = this.querySelectorAll('.cosmic-testimonial-slider__slide');
    this.dots = this.querySelectorAll('.cosmic-testimonial-slider__dot');
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10);
    
    if (!this.track || this.slides.length === 0) return;

    this.currentIndex = 0;
    this.initObserver();
    this.initDots();
    
    if (this.autoplaySpeed > 0) {
      this.initAutoplay();
    }
  }

  initObserver() {
    const options = {
      root: this.track,
      threshold: 0.6
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = parseInt(entry.target.dataset.index, 10);
          this.currentIndex = index;
          this.updateActiveState(index);
        }
      });
    }, options);

    this.slides.forEach(slide => observer.observe(slide));
  }

  initDots() {
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        this.scrollToSlide(index);
        this.resetAutoplay();
      });
    });
  }

  updateActiveState(activeIndex) {
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('is-visible', index === activeIndex);
    });
  }

  scrollToSlide(index) {
    if (this.slides[index]) {
      const scrollLeft = this.slides[index].offsetLeft;
      this.track.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }

  initAutoplay() {
    this.startAutoplay();
    this.track.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
    this.track.addEventListener('mouseenter', () => this.stopAutoplay());
    this.track.addEventListener('mouseleave', () => this.startAutoplay());
    this.track.addEventListener('touchend', () => {
      setTimeout(() => this.startAutoplay(), 3000);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      let nextIndex = this.currentIndex + 1;
      if (nextIndex >= this.slides.length) {
        nextIndex = 0; // Loop back
      }
      this.scrollToSlide(nextIndex);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  resetAutoplay() {
    if (this.autoplaySpeed > 0) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
}

customElements.define('cosmic-testimonial-slider', CosmicTestimonialSlider);
